module.exports = __webpack_public_path__ + "img/mid_apikey.54a1cabe.png";